export class MerchantProduct {
  constructor({
    id,
    merchantId,
    name,
    orderUnit,          // What you order in (box, case, bag)
    pricingUnit,        // What you're billed by (lb, kg, each)
    pricePerPricingUnit,
    estimatedConversion, // Optional: estimated pricing units per order unit (e.g., 40 lbs per box)
    active = true,
    createdAt,
    lastUpdatedAt,
    // Legacy support
    unit,
    unitPrice,
  }) {
    this.id = id;
    this.merchantId = merchantId;
    this.name = name;
    // Support new dual-unit system, with fallback for legacy single-unit products
    this.orderUnit = orderUnit || unit || 'each';
    this.pricingUnit = pricingUnit || unit || 'each';
    this.pricePerPricingUnit = pricePerPricingUnit ?? unitPrice ?? 0;
    this.estimatedConversion = estimatedConversion || null;
    this.active = active;
    this.createdAt = createdAt;
    this.lastUpdatedAt = lastUpdatedAt || null;
  }

  // Check if this product has different order vs pricing units
  hasDualUnits() {
    return this.orderUnit !== this.pricingUnit;
  }

  // Get estimated cost for a given order quantity
  getEstimatedCost(orderQuantity) {
    if (this.hasDualUnits() && this.estimatedConversion) {
      return orderQuantity * this.estimatedConversion * this.pricePerPricingUnit;
    }
    // Same units: price × quantity
    return orderQuantity * this.pricePerPricingUnit;
  }

  // Format price display
  getPriceDisplay() {
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(this.pricePerPricingUnit);

    if (this.hasDualUnits()) {
      return `${formatted}/${this.pricingUnit}`;
    }
    return `${formatted}/${this.orderUnit}`;
  }

  toJson() {
    return {
      merchantId: this.merchantId,
      name: this.name,
      orderUnit: this.orderUnit,
      pricingUnit: this.pricingUnit,
      pricePerPricingUnit: this.pricePerPricingUnit,
      estimatedConversion: this.estimatedConversion,
      active: this.active,
      createdAt: this.createdAt,
      lastUpdatedAt: this.lastUpdatedAt,
    };
  }

  static fromFirebase(doc) {
    const data = doc.data();
    return new MerchantProduct({
      id: doc.id,
      merchantId: data.merchantId,
      name: data.name,
      orderUnit: data.orderUnit,
      pricingUnit: data.pricingUnit,
      pricePerPricingUnit: data.pricePerPricingUnit,
      estimatedConversion: data.estimatedConversion,
      active: data.active !== false,
      createdAt: data.createdAt,
      lastUpdatedAt: data.lastUpdatedAt,
      // Legacy fields for backwards compatibility
      unit: data.unit,
      unitPrice: data.unitPrice,
    });
  }
}
